import { useEffect, useRef } from 'react';

import { WizardStepName } from 'data/ppoints/constants';
import { useAppSelector } from 'redux/hooks';

import Clarity from '@microsoft/clarity';
import useSendGTMAction from 'features/google-tag-manager/hooks/useSendGTMAction';
import { SetupGuideStepDoneGtmAction } from 'features/google-tag-manager/model/actions/setup_guide_step_done.gtm-action';

const SetupGuideStepDoneActionListener = () => {
    const sendGTMAction = useSendGTMAction();

    const { steps, initialized, skippedStepNames } = useAppSelector((state) => state.wizard);

    const reportedStepNames = useRef<Set<WizardStepName> | null>(null);

    useEffect((): void => {
        if (!initialized || !steps) return;

        if (!reportedStepNames.current) {
            reportedStepNames.current = new Set(steps.filter(({ done }) => done).map(({ name }) => name));
            return;
        }

        const alreadyReported = reportedStepNames.current;

        steps
            .filter(({ name, done }) => done && !alreadyReported.has(name))
            .forEach(({ name }): void => {
                sendGTMAction(
                    new SetupGuideStepDoneGtmAction({
                        name,
                        skipped: skippedStepNames.includes(name),
                    })
                ).then((sent: boolean): void => {
                    if (!sent) return;
                    try {
                        Clarity.event('SetupGuideStepDone');
                    } catch (e) {}

                    alreadyReported.add(name);
                });
            });
    }, [steps, initialized, skippedStepNames, sendGTMAction]);

    return null;
};

export default SetupGuideStepDoneActionListener;
